<div class="popup-container">

    <div class="header text-middle roboto-medium">Add Resolution Orders</div>

    <div class="p-3 roboto-medium">

        The resolution has been created successfully.
        Do you want to add orders for this resolution?

    </div>
    <div class="create_footer d-flex justify-content-end align-items-center p-3">
        <button class="cancel me-3 roboto-bold" (click)="close()"> CANCEL </button>
        <button class="black-button me-3 roboto-medium" (click)="onProceed()">PROCEED</button>
    </div>


    <button mat-button mat-dialog-close (click)="close()" class="close black-button">
        X
    </button>
</div>